import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UuidService } from 'src/app/services';

@Component({
  selector: 'app-add-voting-rights-owner',
  templateUrl: './add-voting-rights-owner.component.html',
  styleUrls: ['./add-voting-rights-owner.component.scss']
})
export class AddVotingRightsOwnerComponent {

  constructor(private uuidService: UuidService) { }

  fg: FormGroup = new FormGroup({
    id: new FormControl(this.uuidService.generateFormattedUUID()),
    ownerOfVotingRights: new FormControl(undefined, Validators.required),
    publiclyTradedCompany: new FormControl(undefined, Validators.required),
    percentageOwnership: new FormControl(undefined, [Validators.required, Validators.min(0), Validators.max(100)])
  });

}
